import {HTTP_METHODS} from '../httpMethods'
import {toSafePathSegment, toSafeQueryString} from '@/utils/security/pathSafety'

const toQueryString = queryParams => {
  return toSafeQueryString(queryParams)
}

const withQuery = (path, queryParams) => {
  const queryString = toQueryString(queryParams)
  return queryString ? `${path}?${queryString}` : path
}

export const PRODUCTS_CONFIG = {
  PRODUCT_LIST: queryParams => ({
    endPoint: withQuery('product', queryParams),
    // mockData: ProductListData,
    baseUrlKey: 'inventoryApiUrl',
    method: HTTP_METHODS.POST,
  }),

  PRODUCT_CSV_DOWNLOAD: queryParams => ({
    endPoint: withQuery('product/download', queryParams),
    method: HTTP_METHODS.POST,
    baseUrlKey: 'inventoryApiUrl', // Dynamically use INVENTORY_API_URL
  }),

  PRODUCT_ENRICHMENT_TEMPLATE_DOWNLOAD: queryParams => ({
    endPoint: withQuery('product/enrichment/download', queryParams),
    method: HTTP_METHODS.GET,
    baseUrlKey: 'inventoryApiUrl',
    headers: {
      scope: 'pepsi',
    },
  }),

  UPDATE_PRODUCT: {
    endPoint: 'product',
    method: HTTP_METHODS.PUT,
    baseUrlKey: 'inventoryApiUrl',
  },

  UPLOAD_PRODUCT_MEDIA: productId => ({
    endPoint: `product/${toSafePathSegment(productId)}/image/upload`,
    method: HTTP_METHODS.POST,
    baseUrlKey: 'inventoryApiUrl',
    headers: {
      scope: 'pepsi',
    },
  }),

  BULK_EDIT_PRODUCTS: (extraHeaders = {}) => ({
    endPoint: 'product/bulk',
    method: HTTP_METHODS.PATCH,
    baseUrlKey: 'inventoryApiUrl',
    headers: {
      scope: 'pepsi',
      ...extraHeaders,
    },
  }),
}
